export const getMapBoundariesByCountry = async (country: string): Promise<google.maps.GeocoderResult> => {
  const geocoder = new google.maps.Geocoder();
  const response = await geocoder.geocode({ address: country });

  return response.results[0];
};
